import { ModalWrapper } from "src/utils/fw";
import { auditoriumCloseDate, modalColor } from "../utils";
import VideoModal from "src/components/VideoModal";

const memberLinks = [
	{
		height: "13.6%",
		label: "FAQ",
		left: "23.3%",
		top: "76.7%",
		width: "5.4%",
		href: "https://assets.swoogo.com/uploads/4598661-6723d6eb600d8.pdf",
		target: "_blank"
	},
	{
		label: "Exploration Zone",
		height: "24.2%",
		href: "/exploration-zone",
		left: "56.2%",
		top: "12%",
		width: "13.6%",
	},
]

const general = [
	{
		label: "Auditorium",
		height: "20.2%",
		href: undefined,
		left: "57.2%",
		top: "56%",
		width: "12.6%",
		modal: <ModalWrapper wrapperStyle={{background: modalColor, textAlign: "center"}}>
			<h1 style={{color: "white"}}>The Auditorium is now closed.</h1>
			<p style={{color: "white"}}>Please head over to our On-Demand Rooms to view session recordings, and browse through our ISF Exploration Zone and Exhibition Hall until Wednesday 4 December</p>
		</ModalWrapper>,
		modalOverrides: {
			dismissHTML:"X",
			dismissStyle:{color: "white", fontSize: "18px", top: "9px", right: "13px"},
		},
	},
	{
		label: "Exibition Hall",
		height: "26.2%",
		href: "/exhibition-hall",
		left: "26.2%",
		top: "57%",
		width: "11.6%",
	},
	{
		label: "On Demand",
		href: new Date() > new Date("2023-10-22 08:00:00+0200") ? "/on-demand" : undefined,
		width: "7.6%",
		height: "18.2%",
		left: "28.2%",
		top: "37%",
		modal: new Date() > new Date("2023-10-22 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: modalColor}}>
			<h1 style={{color: "white"}}>On-Demand sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
		</ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		height: "13.4%",
		label: "Welcome",
		left: "53.5%",
		top: "41.4%",
		width: "18.6%",
		modal: <ModalWrapper wrapperStyle={{
            backgroundColor: modalColor, 
            color: "white",
            aspectRatio: "16 / 9",
            width: "50%",
            minWidth: "700px"}}>
            <VideoModal url="https://player.vimeo.com/video/991467648?autoplay=1" />
        </ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	}
]

export default {
	background: "https://assets.swoogo.com/uploads/full/4599731-67240ce604399.png",
	links: [...general, ...memberLinks, {
		top: "53%",
        left: "71.6%",
        width: "13%",
        height: "14.5%",
		modal: <ModalWrapper wrapperStyle={{
            backgroundColor: modalColor, 
            color: "white",
            aspectRatio: "16 / 9",
            width: "50%",
            minWidth: "700px"}}>
            <VideoModal url="https://player.vimeo.com/video/1025075872?autoplay=1" />
        </ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	}],
	name: "atrium",
}
